import React from "react";
import { Link } from "react-router-dom";
import "./Banner.css";
import demoVideo from "../public/coinbasis-demo-video.mp4";

const Banner = ({ pricingRef }) => {
  const scrollToPricing = () => {
    if (pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="banner-section">
      <div className="banner-container">
        <div className="banner-text-content">
          <p className="banner-subtitle">
            Providing accurate cost basis tracking and tax reporting for
            cryptocurrency traders
          </p>
          <div className="banner-cta-group">
            <div className="banner-cta">
              <Link to="/estimator" className="primary-button">
                Try It Free
              </Link>
              <Link to="/howitworks" className="primary-button">
                See How It Works
              </Link>
            </div>
            <div className="banner-cta-secondary">
              <button onClick={scrollToPricing} className="secondary-button">
                View Pricing
              </button>
            </div>
          </div>
        </div>
        <div className="banner-video-content">
          <video 
            className="banner-demo-video"
            autoPlay 
            loop 
            muted 
            playsInline
          >
            <source src={demoVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default Banner;
